export namespace ICarRequest {
  export enum Action {
    CarsMK = 'Cars_MK',
  }

  export enum Command {
    Get = 'get',
    Set = 'set',
    Add = 'add',
    Update = 'upd',
    Delete = 'del',
    RemoveFromHistory = 'delCarsHistory',
    GetEventsLog = 'EventsLog',
  }
}